export default __webpack_public_path__ + "static/media/Game 3 The restauranteur.775aa40f.png";